import { RouterProvider, createBrowserRouter } from "react-router-dom"
import { useAuthState } from "react-firebase-hooks/auth"
import { auth } from "./firebase"
import LoginPage from "./pages/login/login.page"
import DashboardPage from "./pages/dashboard/dashboard.page"
import WithProtection from "./withProtection"
import WithSidebar from "./withSidebar"
import { useState, useEffect, createContext } from "react"
// import LabsPage from "./pages/labs/labs.page"
// import DevicesPage from "./pages/devices/devices.page"
// import OperatorsPage from "./pages/operators/operators.page"
// import PatientsPage from "./pages/patients/patients.page"
import TestsPage from "./pages/tests/tests.page"
import SpinnerComponent from "./components/spinner/spinner.component"
import SettingsPage from "./pages/settings/settings.page"
import API from "./api"
// import ReportPage from "./pages/report/report.page"
import TestDetailPage from "./pages/test-detail/test-detail.page"
import CohortAnalysisPage from "./pages/cohort-analysis/cohort-analysis.page"
import PatientsPage from "./pages/patients/patients.page"
import TrialsPage from "./pages/trials/trials.page"

const SettingsContext = createContext()

const CellsBin = () => {
  const [user, loading] = useAuthState(auth)
  const [role, setRole] = useState()
  const [userMeta, setUserMeta] = useState()
  const [fetchingClaims, setFetchingClaims] = useState(true)
  const [settings, setSettings] = useState()

  const router = createBrowserRouter([
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/dashboard",
      element: (
        <WithProtection user={user}>
          <WithSidebar user={user} role={role} userMeta={userMeta}>
            <DashboardPage user={user} role={role} userMeta={userMeta} />
          </WithSidebar>
        </WithProtection>
      ),
    },
    {
      path: "/patients",
      element: (
        <WithProtection user={user}>
          <WithSidebar user={user} role={role} userMeta={userMeta}>
            <PatientsPage user={user} role={role} userMeta={userMeta} />
          </WithSidebar>
        </WithProtection>
      ),
    },
    {
      path: "/trials",
      element: (
        <WithProtection user={user}>
          <WithSidebar user={user} role={role} userMeta={userMeta}>
            <TrialsPage user={user} role={role} userMeta={userMeta} />
          </WithSidebar>
        </WithProtection>
      ),
    },
    {
      path: "/tests",
      element: (
        <WithProtection user={user}>
          <WithSidebar user={user} role={role} userMeta={userMeta}>
            <TestsPage user={user} role={role} userMeta={userMeta} />
          </WithSidebar>
        </WithProtection>
      ),
    },
    {
      path: "/cohort-analysis",
      element: (
        <WithProtection user={user}>
          <WithSidebar user={user} role={role} userMeta={userMeta}>
            <CohortAnalysisPage user={user} role={role} userMeta={userMeta} />
          </WithSidebar>
        </WithProtection>
      ),
    },
    {
      path: "/settings",
      element: (
        <WithProtection user={user}>
          <WithSidebar user={user} role={role} userMeta={userMeta}>
            <SettingsPage user={user} role={role} userMeta={userMeta} />
          </WithSidebar>
        </WithProtection>
      ),
    },
    {
      path: "/tests/:testId",
      element: (
        <WithProtection user={user}>
          <WithSidebar user={user} role={role} userMeta={userMeta}>
            <TestDetailPage user={user} role={role} userMeta={userMeta} />
          </WithSidebar>
        </WithProtection>
      ),
    },
    {
      path: "/*",
      element: <LoginPage />,
    },
  ])

  // Fetch claims & labs if we have a user
  useEffect(() => {
    if (loading) return

    const getClaims = async () => {
      try {
        setFetchingClaims(true)
        const { claims } = await user.auth.currentUser.getIdTokenResult()
        setRole(claims?.role)
        setUserMeta({ fullName: claims?.fullName })

        // Fetch labs
        // const labs = await API.makeGetRequest(user, "labs")

        // Fetch settings
        const settings = await API.makeGetRequest(user, "users")
        const theme = settings?.preferences?.theme
        document.documentElement.classList.add(`theme-${theme}`)

        // Set
        setSettings({
          preferences: settings?.preferences,
          filters: settings?.filters,
          setSettings,
        })
      } catch {
        // todo handle error
      } finally {
        setFetchingClaims(false)
      }
    }

    if (user) {
      getClaims()
    } else {
      setFetchingClaims(false)
    }
  }, [user, loading])

  return (
    <SettingsContext.Provider value={settings}>
      <div className="cellsbin">
        {(loading || fetchingClaims) && <SpinnerComponent />}
        {!loading && !fetchingClaims && <RouterProvider router={router} />}
      </div>
    </SettingsContext.Provider>
  )
}

export default CellsBin
export { SettingsContext }
